<modal-layout-right (close)="close()">
    <ng-container ngProjectAs="[modalTitle]">
        <h4 class="w-12 h4 center">{{'Filters' | translate}}</h4>
    </ng-container>

    <div modalBody>
        <div class="p-b-4-s p-t-7-s p-r-6 p-l-8 p-l-6-s">
            <!-- sort listing -->
            <expandable class="h4"
                        [expandableId]="['filter', 'sort-options']"
                        expandableIcon="chevron">
                <div expandableTitle
                     [zippyName]="['filter', 'sort-options']"
                     zippyClass="col-12">
                    {{'Sort by' | translate}}
                    <div class="pos-absolute right-0 top-50 p1 col-12">
                        {{sortSelectedLabel | translate}}
                    </div>
                </div>
                <div expandableBody>
                    <div #expandableBody>
                        <ng-container *ngComponentOutlet="
                                                            sortOutlet.component;
                                                            inputs: sortOutlet.inputs;
                                                            " />
                    </div>
                </div>
            </expandable>
            @for (filter of getFilterOptions(); track $index) {
            <div>
                <ng-container *ngComponentOutlet="
                                                getFilterOutlet(filter).component;
                                                inputs:  getFilterOutlet(filter).inputs;
                                                " />
            </div>
            }
        </div>
    </div>

    <!-- filter buttons -->
    <div modalFooter
         class="w-12 flex flex-justify-center p-t-9 p-t-7-s p-r-8 p-r-6-s p-b-9 p-b-7-s p-l-8 p-l-6-s">
        <!-- clear -->
        <button class="button-1 m-r-3 m-r-5-s w-5 w-6-s"
                (click)="clearFilters()">
            <span class="button__body">{{'Clear All' | translate}}</span>
        </button>

        <!-- close -->
        <button class="button w-5 w-6-s"
                (click)="close()"
                modalClose>
            <span class="button__body">{{'Apply' | translate}}</span>
        </button>
    </div>
</modal-layout-right>